import {makeAutoObservable} from 'mobx';
import {Roles} from "../AppConstants";

export type SiteDTO = FilterGroupDTO & {
    // regionId: string
}
export type DeviceTTO = SiteDTO & {
    siteId: string
}
export type DeviceResponseDTO = FilterGroupDTO & {
    siteId: string
    area: {
        site: FilterGroupDTO & {
            location: {
                region: FilterGroupDTO
            }
        }
    }
}
export type FilterGroupDTO = {
    id: string;
    name: string;
    manager?: string;
    canDelete?: boolean;
}

export type AdminOrganizationDTO = {
    id: string;
    name: string;
    settings: {[key: string]: string[]} | null;
}
export class FilterDTO {
    customers: FilterGroupDTO[] = [];
    sites: SiteDTO[] = [];
    plants: DeviceTTO[] = [];

    constructor() {
        makeAutoObservable(this);
    }
}

/*TODO: Remove Old Models*/

export type ResponseDTO<T> = {
    result: T[]
    skip: number
    take: number
    count: number
}

export type KeyString = { [key: string]: string }

export type AlarmGroups = {
    deviceId: string
    count: number
    name: number
    id: string
    ratio: number
}
export type AlarmsDTO = {
    deviceId: string
    name: string
    text: string
    count: number
    ratio: number
}
export type MetricsDTO = {
    deviceId: string
    groupId: string
    groupName: string
    componentId: string
    componentName: string
    name: string
    category: string
    ratio: number
    ratioLowerLimit: number
}
export type ComponentDTO = {
    id: string;
    name: string;
    group: ComponentDTO | null;
    category: string | null;
}
export type ComponentMetricsDTO = {
    deviceId: string;
    name: string;
    value: number;
    unit: number | null;
    limits: number[];
    component: ComponentDTO;
    componentMetrics: ComponentMetricsDTO[];
}

export type DeviceMetricsDTO = {
    deviceId: string;
    siteId: string;
    name: string;
    value: number;
    unit: number | null;
    limits: number[];
    componentMetrics: ComponentMetricsDTO[];
}

export type AlarmStats = {
    deviceId: string
    count: number
    name: string
    ratio: number
    level: number
}

export type AlarmGroupStatsDTO = {
    deviceId: string
    name: string
    count: number
    ratio: number
}

export type SiteInfoDTO = {
    id: string,
    name: string,
    isPublic: boolean,
    latitude: number,
    longitude: number,
    address: string
    url: string,
    tags: {
        phone?: string
        email?: string
    }
    plant?:string;
}

export type Marker = SiteInfoDTO & ContactDTO;

// ToDo: Should be removed. ConditionsDTO should be used
export type ConditionDTO = {
    alarms: AlarmsDTO[],
    alarmGroups: AlarmGroups[],
    metrics: MetricsDTO[],
}

export type ConditionsDTO = {
    alarmGroupStats: AlarmGroupStatsDTO[],
    alarmStats: AlarmStats[],
    deviceMetrics: DeviceMetricsDTO[],
}

export enum MaintenanceStatus {
    Pending = "Pending",
    Completed = "Completed",
    Cancelled = "Cancelled"
}

export type MaintenanceDTO = {
    name: string
    taskId: string
    overdue: number
    due: number
    value: number,
    initialValue: number,
    timestamp: string,
    timeDelta: string,
    componentId: string,
    status: MaintenanceStatus,
    completed: Date,
    time: Date,
    description: string,
    comment: string,
    userLog: {
        id: string,
        message: string,
        displayName: string,
        email: string
    },
    type: string,
    measurement: string,
    log: string,
    valueDelta: number,
    isAlmostDue: boolean,
    isRecurring?: boolean,
    initialTime?: Date,
    timeD?: number,
    timeH?: number,
    deviceId: string,
    operatingHoursPerWeek?: number,
    operatingHours?: number,
    isManualDuration?: boolean,
    ticketId: string
}

export type NewMaintenanceDTO = {
    description: string,
    deviceId: string,
    organizationId: string,
    isRecurring: boolean,
    status?: MaintenanceStatus,
    userId?: string,
    ticketId?: string,
    value?: number,
    logMessage?: string,
    log?: string,

    measurement?: string,
    valueDelta?: number,
    initialTime?: string,
    timeDelta?: string,
}
export type MeasurementDTO = {
    id: string,
    name: string,
    unit: string,
    componentId: string,
    category: string,
    ratioLimit: number,
}

export type ContactDTO = {
    id: string,
    name: string,
    address: string,
    phone: string,
    url: string,
    latitude: number,
    longitute: number
}

export type ConditionChartDataDTO = {
    current: ConditionsDTO,
    historical: ConditionDTO,
    inspection: MaintenanceDTO[],
    revision: MaintenanceDTO[]
}

export type EfficiencyEnergyDTO = {
    deviceId: string,
    name: string,
    siteId: string,
    unit: string,
    value: number,
    componentMetrics: ComponentMetricsDTO[],
    limits: number[],
}

export type EfficiencyKpiDTO = {
    deviceMetrics: EfficiencyEnergyDTO[],
    limits: number[],
    name: string,
    siteId: string,
    unit: string,
    value: string | number,
}

export type EfficiencyDTO = {
    effectiveness: EfficiencyKpiDTO[],
    specificEnergyConsumption: EfficiencyKpiDTO[]
    totalEnergyConsumption: EfficiencyKpiDTO[]
    totalRawMaterialConsumption: EfficiencyKpiDTO[]
    throughput: EfficiencyKpiDTO[]
}

export type EfficiencyChartDataDTO = {
    current: EfficiencyDTO,
    historical: EfficiencyDTO,
}
export type SiteEfficiencyDTO = {
    siteId: string,
    name: string,
    value: number,
    limits: number[],
    unit: string,
    deviceMetrics: EfficiencyEnergyDTO[],
    // overall: number,
    // overallLowerLimit: number,
}

export enum TicketType {
    Incident = "Incident",
    Request = "Request"
}

export enum TaskType {
    scheduled = "Scheduled Based",
    data = "Data Based"
}

export enum TicketPriority {
    Low = "Low",
    Normal = "Normal",
    High = "High",
}

export enum TicketClassification{
    ControlSystems = "Control Systems",
    Mechanical = "Mechanical",
    ProcessTechnology = "Process Technology",
    General = "General",
}

export type ComponentTDO = {
    id: string,
    name: string
}
export type OptionTDO = {
    value: string,
    label: string
}

export enum ServiceChangeKey {
    isResolved = 'isResolved',
    isNotResolved = 'isNotResolved',
}

export type AttachmentTDO = {
    id: string,
    name: string
    createdOn: string
    contentType: string
}


export enum SupportTicketStatusDTO {
    InProgress = 'InProgress',
    MarkedForClosing = 'MarkedForClosing',
    OnHold = 'OnHold',
    WaitingForDetails = 'WaitingForDetails',
    Researching = 'Researching',
    CreateQuotes = 'CreateQuotes',
    CreateOrders = 'CreateOrders',
    WaitingOnCustomerOrder = 'WaitingOnCustomerOrder',
    NotStarted = 'NotStarted',
    ProblemSolved = 'ProblemSolved',
    InformationProvided = 'InformationProvided',
    LeadCreated = 'LeadCreated',
    Cancelled = 'Cancelled',
    Merged = 'Merged',
    UnsolvedClosed = 'UnsolvedClosed',
    TicketSolved = 'TicketSolved'
}

export const SupportTicketStatusLabelDTO: KeyString = {
    [SupportTicketStatusDTO.InProgress as string]: 'In Progress',
    [SupportTicketStatusDTO.MarkedForClosing as string]: 'Marked For Closing',
    [SupportTicketStatusDTO.OnHold as string]: 'On Hold',
    [SupportTicketStatusDTO.WaitingForDetails as string]: 'Waiting For Details',
    [SupportTicketStatusDTO.Researching as string]: 'Researching',
    [SupportTicketStatusDTO.CreateQuotes as string]: 'Create Quotes',
    [SupportTicketStatusDTO.CreateOrders as string]: 'Create Orders',
    [SupportTicketStatusDTO.WaitingOnCustomerOrder as string]: 'Waiting On Customer Order',
    [SupportTicketStatusDTO.NotStarted as string]: 'Not Started',
    [SupportTicketStatusDTO.ProblemSolved as string]: 'Problem Solved',
    [SupportTicketStatusDTO.InformationProvided as string]: 'Information Provided',
    [SupportTicketStatusDTO.LeadCreated as string]: 'Lead Created',
    [SupportTicketStatusDTO.Cancelled as string]: 'Cancelled',
    [SupportTicketStatusDTO.Merged as string]: 'Merged',
    [SupportTicketStatusDTO.UnsolvedClosed as string]: 'Unsolved Closed',
    [SupportTicketStatusDTO.TicketSolved as string]: 'Ticket Solved',
};

export type SupportTicketDTO = {
    id: string,
    status?: string,
    title: string,
    type: TicketType,
    priority: TicketPriority,
    classification: TicketClassification;
    deviceId: string,
    componentId?: string,
    componentIds: string[],
    category?: string,
    userId: string |  {
        id: string,
        displayName: string
    },
    siteId: string,
    number: string,
    description: string,
    slaStatus: string,
    currentSlaEffort: string,
    taskId?: string,
    createdOn: Date,
    modifiedOn: Date,
    resolvedOn?: Date,
    summaryAttachmentId?: string,
    isResolved: boolean,
    user: {
        id: string,
        displayName: string,
    },
    isInCompletedTask?: boolean
}


export type CommentTDO = {
    id: string,
    content: string,
    createdOn: Date,
    modifiedOn: Date,
    attachments: AttachmentTDO[],
    isCustomerBound: boolean,
    user: {
        id: string,
        displayName?: string,
    }
}

export enum UserRoleDTO {
    Admin = "Admin",
    User = "User",
    None = "None",
}

export type UserDTO = {
    id: string,
    displayName: string,
    email?: string,
    userId: string,
    role: Roles,
    organizationId: string,
    siteId: string,
    areaId: string,
    deviceId: string,
}

export type UserPermissionsDTO = {
    id?: string,
    organizationId?: string,
    siteId?: string,
    deviceId?: string,
    userId?: string,
}

export type UserPermission = {
    id?: string,
    user?: string,
    userDisplayName?: string,
    familyName?: string,
    givenName?: string,
    entity?: string,
    email?: string,
    customer?: string,
    site?: string,
    plant?: string
}

export type User = {
    displayName: string,
    email?: string,
    userId: string,
}

export type RegionUserDTO = User & {
    regionId: string
}